(function($) {
	formHelper.addRule({
		form: '.form-search-premium-transactions',
		xhrBeforeSend: function() {
			$(".form-search-premium-transactions select").each(function() {
				if(this.value.indexOf("ImpersonateMyAccountUser") > -1) {
					window.open(this.value, '_blank');
					this.cancel();
				}
			});
		},
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsSearchPremiumTransactions($) {
	$('.search-premium-transactions-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-premium-transactions');

		i=1;
		// Date Range form elements
		// ------------------
		var $dateRangeStart = $('#date-range-start-' + i).pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateRangeStartPicker = $dateRangeStart.pickadate('picker');

		var $dateRangeEnd = $('#date-range-end-' + i).pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateRangeEndPicker = $dateRangeEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( dateRangeStartPicker.get('value') ) {
			dateRangeEndPicker.set('min', dateRangeStartPicker.get('select'));
		}
		
		if ( dateRangeEndPicker.get('value') ) {
			dateRangeStartPicker.set('max', dateRangeEndPicker.get('select'));
		}
		

		// When something is selected, update the date range limits.
		$('#date-range-start-1').pickadate('picker').on('set', function(event) {
			if ( event.select ) { $('#date-range-end-1').pickadate('picker').set('min', $('#date-range-start-1').pickadate('picker').get('select')); }
			else if ( 'clear' in event ) { $('#date-range-end-1').pickadate('picker').set('min', false); }
		});

		$('#date-range-end-1').pickadate('picker').on('set', function(event) {
			if ( event.select ) { $('#date-range-start-1').pickadate('picker').set('max', $('#date-range-end-1').pickadate('picker').get('select')); }
			else if ( 'clear' in event ) { $('#date-range-start-1').pickadate('picker').set('max', false); }
		});
	});
});

jQuery(function initToolsSearchTransactionsResults($) {
	$('.search-premium-transactions-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-premium-transactions-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for (var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});


jQuery(function($) {
	$('.js-search-premium-transactions-actions').change(function() {
		if($(this).val() !== '') {
			document.location.href = $(this).val();
		}
	});
});
